export default __webpack_public_path__ + "static/media/MobileLanding.83a5ec39.svg";